import { GFFieldComponentProps } from "eddev/integrations/gravityforms"
import { Checkbox } from "./Checkbox"
import { validateChoiceLimit } from "@components/forms/validateChoiceLimit"
import { useState } from "react"

export function CheckboxGroup(props: GFFieldComponentProps<"checkbox">) {
  const [error, setError] = useState<string | null>(null)
  const value = props.value ?? []

  const { choiceLimit, choiceLimitNumber, choiceLimitMin, choiceLimitMax } = props

  const validateAndSet = (next: string[]) => {
    const errorMsg = validateChoiceLimit({
      selected: next,
      choiceLimit,
      choiceLimitNumber,
      choiceLimitMin,
      choiceLimitMax,
    })

    setError(errorMsg)
    props.set(next)
  }

  return (
    <div className={`checkbox-group ${props.type === "image_choice" ? `flex flex-row gap-4 flex-wrap` : ``}`}>
      {props.choices.map((choice, index) => {
        const val = String(choice.value)
        const isChecked = value.includes(val)
        const imageChoice = choice as typeof choice & { file_url?: string }

        return (
          <Checkbox
            file_url={imageChoice.file_url}
            key={index}
            label={imageChoice.text}
            name={props.name}
            checked={isChecked}
            onCheckedChange={(checked) => {
              const updated = checked ? [...value.filter((v) => v !== val), val] : value.filter((v) => v !== val)

              validateAndSet(updated)
            }}
          />
        )
      })}

      {error && <p className="mt-2 type-label-m text-accent">{error}</p>}
    </div>
  )
}
